export default {
  state: {
    meetingTypes: [],
  },
  getters: {
    meetingTypeList: state => state.meetingTypes, // 空间类型枚举
  },
  mutations: {
    setMeetingTypeLists(state, list) {
      state.meetingTypes = list;
    },
  },
  actions: {},
};
